// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"268":"events","353":"contact","594":"about"}[chunkId] + "." + {"268":"027b9388","353":"221269a5","594":"ed05eebb"}[chunkId] + ".css";
};